/* ACKAVE Sport — theme.js
   Progressive enhancement only. Pages are real Shopify URLs and the
   order form submits natively to Shopify, so there is no client-side
   routing here. */
(function () {
  'use strict';

  // Current year (footer)
  var yr = document.getElementById('ack-year');
  if (yr) yr.textContent = new Date().getFullYear();

  // Fill cross-stitch divider glyphs
  var line = '✕ '.repeat(120);
  document.querySelectorAll('.stitch span').forEach(function (e) {
    if (!e.textContent.trim()) e.textContent = line;
  });

  // Seamless marquee loop (duplicate track content once)
  document.querySelectorAll('[data-marquee]').forEach(function (mq) {
    mq.innerHTML = mq.innerHTML + mq.innerHTML;
  });

  // Mobile nav toggle
  var menuBtn = document.getElementById('menuBtn');
  var tabs = document.getElementById('tabs');
  if (menuBtn && tabs) {
    var setMenu = function (open) {
      tabs.classList.toggle('open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', open);
    };
    menuBtn.addEventListener('click', function () {
      setMenu(!tabs.classList.contains('open'));
    });
    // Close on escape, on any nav link, and when we grow past the mobile breakpoint
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && tabs.classList.contains('open')) { setMenu(false); menuBtn.focus(); }
    });
    tabs.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
    var wide = window.matchMedia('(min-width:721px)');
    var onWide = function (e) { if (e.matches) setMenu(false); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);

    // Drop-downs are accordions on mobile; on desktop the caret button is decorative
    tabs.querySelectorAll('.sub-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (wide.matches) { e.preventDefault(); return; }
        var wrap = btn.closest('.tab-wrap');
        var open = wrap.classList.toggle('sub-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    // Open the drop-down containing the current page
    tabs.querySelectorAll('.subtab.active').forEach(function (a) {
      var wrap = a.closest('.tab-wrap');
      if (wrap) {
        wrap.classList.add('sub-open');
        var b = wrap.querySelector('.sub-toggle');
        if (b) b.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // Reveal-on-scroll
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  // Order form: live total from size breakdown + filename display
  var form = document.querySelector('form.order');
  if (form) {
    var sizeNames = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
    var sizeInputs = sizeNames
      .map(function (n) { return form.querySelector('[data-size="' + n + '"]'); })
      .filter(Boolean);
    var totalInput = form.querySelector('[data-total]');
    if (totalInput && sizeInputs.length) {
      var sumSizes = function () {
        var t = sizeInputs.reduce(function (a, i) { return a + (parseInt(i.value, 10) || 0); }, 0);
        if (t > 0) totalInput.value = t;
      };
      sizeInputs.forEach(function (i) { i.addEventListener('input', sumSizes); });
    }
    var art = form.querySelector('[data-file]');
    var fileName = form.querySelector('[data-filename]');
    if (art && fileName) {
      var placeholder = fileName.textContent;
      art.addEventListener('change', function () {
        fileName.textContent = art.files && art.files[0] ? art.files[0].name : placeholder;
      });
    }
  }

  // If the contact form just posted, scroll to the confirmation panel
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    var panel = document.getElementById('order-confirmation');
    if (panel) panel.scrollIntoView({ behavior: 'smooth' });
  }

  // Lightbox — click an image to view it full-size. Moodboard tiles and gallery
  // cards are grouped by their container, so prev/next stays within one grid.
  (function () {
    var hasImg = function (el) { return el.querySelector('img') || el.getAttribute('data-full'); };
    var all = Array.prototype.slice.call(document.querySelectorAll('.mood .tile, .teams .ph:not(.ph-link)')).filter(hasImg);
    if (!all.length) return;

    var containers = [];
    all.forEach(function (el) {
      var c = el.closest('.mood, .teams') || document.body;
      if (containers.indexOf(c) === -1) containers.push(c);
    });
    var groups = containers.map(function (c) {
      return Array.prototype.slice.call(c.querySelectorAll('.tile, .ph:not(.ph-link)')).filter(hasImg);
    });

    var overlay = document.createElement('div');
    overlay.className = 'lb';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="lb-backdrop" data-lb-close></div>' +
      '<div class="lb-dialog" role="dialog" aria-modal="true" aria-label="Image viewer">' +
      '<button class="lb-btn lb-close" type="button" data-lb-close aria-label="Close">×</button>' +
      '<button class="lb-btn lb-prev" type="button" aria-label="Previous image">‹</button>' +
      '<figure class="lb-figure"><img class="lb-img" alt=""><figcaption class="lb-cap"></figcaption></figure>' +
      '<button class="lb-btn lb-next" type="button" aria-label="Next image">›</button>' +
      '</div>';
    document.body.appendChild(overlay);

    var imgEl = overlay.querySelector('.lb-img');
    var capEl = overlay.querySelector('.lb-cap');
    var cur = 0, idx = 0, lastFocus = null;

    var fullOf = function (t) { return t.getAttribute('data-full') || (t.querySelector('img') || {}).src || ''; };
    var capOf = function (t) {
      var c = t.getAttribute('data-caption');
      if (c) return c;
      var tag = t.querySelector('.tag');
      if (tag) return tag.textContent.trim();
      var card = t.closest('.team');
      if (card) { var h = card.querySelector('.cap h3'); if (h) return h.textContent.trim(); }
      return '';
    };
    var show = function (i) {
      var arr = groups[cur];
      idx = (i + arr.length) % arr.length;
      var t = arr[idx], cap = capOf(t);
      imgEl.src = fullOf(t);
      imgEl.alt = cap;
      capEl.textContent = cap;
      capEl.style.display = cap ? '' : 'none';
      overlay.classList.toggle('solo', arr.length < 2);
    };
    var open = function (g, i) {
      cur = g;
      lastFocus = document.activeElement;
      show(i);
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      overlay.querySelector('.lb-close').focus();
    };
    var close = function () {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      imgEl.removeAttribute('src');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    groups.forEach(function (arr, g) {
      arr.forEach(function (t, i) {
        t.addEventListener('click', function (e) { e.preventDefault(); open(g, i); });
      });
    });
    overlay.querySelector('.lb-prev').addEventListener('click', function () { show(idx - 1); });
    overlay.querySelector('.lb-next').addEventListener('click', function () { show(idx + 1); });
    Array.prototype.forEach.call(overlay.querySelectorAll('[data-lb-close]'), function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  })();
})();
